import React, { useEffect, useState } from "react";
import { SearchOutlined, EyeOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, PlusSquareFilled } from '@ant-design/icons';
import { DatePicker, Modal, Col, Row, Table, Space, Button, Form, FormInstance, Input } from 'antd';
import { AlignType } from 'rc-table/lib/interface';
import dayjs from 'dayjs';

import { SelecionarArquivo } from "../../../components/Documentos/SelecionarArquivo";
import { errorMessage, mostrarInfo, successMessage } from "../../../utils/messages";
import { IDocumentoPessoaFisicaPenalidade } from "./InterfacePessoaFisica";
import { IChaves } from "../../../Interfaces/Interfaces";
import { disabledDate, hasText } from "../../../utils/utilsFunctions";
import { getDocPdf } from "../../../services/apiDocumentos";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  documentos: IDocumentoPessoaFisicaPenalidade[];
  setDocumentos: React.Dispatch<React.SetStateAction<IDocumentoPessoaFisicaPenalidade[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
  docJustificativa: boolean;
}

export interface ICampos {
  visible?: string[];
  default?: string[];
  defaultNumberSelect?: number[];
  required?: number[];
  disabled?: number[];
}

const PessoaFisicaPenalidadeDocumento = ({ form, documentos, setDocumentos, manter, docJustificativa }: IProps) => {

  const [chave, setChave] = useState<number|undefined>();
  const [fileList, setFileList] = useState<IChaves>();

  const [exibirModalDoc, setExibirModalDoc] = useState(false);
  const [exibirDocCadastrado, setExibirDocCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");


  useEffect(() => {
    if (documentos.length === 0) {
      setExibirDocCadastrado("none")
    } else {
      setExibirDocCadastrado("inline")
    }
  }, [documentos]);

  useEffect(() => {
    if (chave) {
      setFileList(
        {
          idDocumento: chave,
        },
      );
    }
  }, [chave]);


  useEffect(() => {
    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("nuProcesso"))) {
      mostrarInfo("Não é possível incluir novos documentos", "Processo ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalDoc(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarDoc = () => {
    if (!fileList || !fileList.idDocumento) {
      errorMessage("Selecione um arquivo para 'upload'.");
    } else {
      form
        .validateFields([
          "idCertificadoraDocumento",
          "nmDocumentoPfPenalidade",
          "nuDocumentoPfPenalidade",
          "dtDocumentoPfPenalidade",
          // "arquivoDocPfPenalidade",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosDocumento();
          successMessage("Documento Adicionado");
        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido ou não validado");
        });
    }
  };

  function setDadosDocumento() {
    setDocumentos([
      ...documentos,
      {
        idPessoaFisicaPenalidadeDocumento: -1,
        nmDocumento: form?.getFieldValue("nmDocumentoPfPenalidade") ? form?.getFieldValue("nmDocumentoPfPenalidade").toUpperCase() : undefined,
        nuDocumento: form?.getFieldValue("nuDocumentoPfPenalidade") ? form?.getFieldValue("nuDocumentoPfPenalidade").toUpperCase() : undefined,
        dtDocumento: form?.getFieldValue("dtDocumentoPfPenalidade") ? dayjs(form?.getFieldValue("dtDocumentoPfPenalidade")).format("YYYY-MM-DD") : "",
        docJustificativa: docJustificativa,
        idDocumento: chave,
        documentoChave: fileList,
        statusReg: 1,
        touched: true,
      },
    ]);
    form.resetFields([
      "idCertificadoraDocumento",
      "nmDocumentoPfPenalidade",
      "nuDocumentoPfPenalidade",
      "dtDocumentoPfPenalidade",
    ]);
    setChave(undefined);
    setFileList(undefined);
  }

  const columns = [
    {
      key: "1",
      title: "Nome do Documento",
      dataIndex: "nmDocumento",
      // render: (IDoc: IDocumentoPessoaFisicaPenalidade) => <>{IDoc.nmDocumento}</>,
    },
    {
      key: "2",
      title: "Número",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisicaPenalidade) => <>{IDoc.nuDocumento}</>,
    },
    {
      key: "3",
      title: "Data",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisicaPenalidade) => (
        <>
          {IDoc.dtDocumento !== undefined && IDoc.dtDocumento !== "" && dayjs(IDoc.dtDocumento).format("DD/MM/YYYY")}
        </>
      ),
    },
    {
      key: "8",
      title: "", // SEM TÍTULO PARA NÃO EXIBIR A COLUNA. ESTA COLUNA É SOMENTE PARA O FILTRO. DEVE TER UMA FORMA DE USAR HIDDEN.
      dataIndex: "docJustificativa",
      width: 0,
      filters: [{ text: "true", value: true }, { text: "false", value: false }],
      onFilter: (value: any, record: any) => record.docJustificativa === value,
      defaultFilteredValue: [docJustificativa],
      filterIcon: () => { return <SearchOutlined style={{ display: 'none' }} /> },
    },


    {
      // Apenas Marca ou desmarca o campo ativo. Não existe a opção de alteração de documento. Somente exclusão e inclusão de um novo.
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoPessoaFisicaPenalidade) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <DeleteOutlined
                title="Excluir documento ainda não gravado na base."
                style={{ color: "red", display: (IDoc?.idPessoaFisicaPenalidadeDocumento && IDoc?.idPessoaFisicaPenalidadeDocumento < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setDocumentos(documentos.filter((doc) => doc !== IDoc));
                }}
              />
            </div>

            <div style={{ display: (IDoc?.idPessoaFisicaPenalidadeDocumento && IDoc?.idPessoaFisicaPenalidadeDocumento > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    IDoc.statusReg = IDoc.statusReg === 1 ? 2 : 1;
                    IDoc.touched = true;
                    setDocumentos(pre => {
                      return pre.map(doc => {
                        if (doc.idPessoaFisicaPenalidadeDocumento === IDoc.idPessoaFisicaPenalidadeDocumento) {
                          return IDoc;
                        } else {
                          return doc;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IDoc.statusReg = (IDoc.statusReg === 1 ? 2 : 1);
                    IDoc.touched = true;
                    setDocumentos(pre => {
                      return pre.map(doc => {
                        if (doc.idPessoaFisicaPenalidadeDocumento === IDoc.idPessoaFisicaPenalidadeDocumento) {
                          return IDoc;
                        } else {
                          return doc;
                        }
                      });
                    });
                  }}
                />
              </>

            </div>
          </Space>
      ),
    },
    {
      key: "111",
      title: "Arquivo",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoPessoaFisicaPenalidade) => (
        <Button
          id="arquivo"
          shape="round"
          icon={<EyeOutlined />}
          htmlType="button"
          onClick={() => {
            getDocPdf(IDoc.idDocumento!);
          }}
        />
      ),
    },

  ];


  return (
    <>

      <Button

        style={{ display: exibirElementoAcaoAlteracao }}
        shape='round'
        onClick={() => {
          controleDaGrid("incluir documento");
        }}
        type='primary'
        icon={<PlusOutlined />}
      >
        Incluir Documento
      </Button>
      <>

        <Modal title="Documento" open={exibirModalDoc}
          style={{ top: 20 }}
          width={750}
          destroyOnHidden={true}
          onCancel={() => {
            controleDaGrid("cancelar");
            form.resetFields([
              "idCertificadoraDocumento",
              "nmDocumentoPfPenalidade",
              "nuDocumentoPfPenalidade",
              "dtDocumentoPfPenalidade",
              // "arquivoDocPfPenalidade",
            ]);
          }}
          closable={false}
          cancelText="Cancelar"
          cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          onOk={() => {
            validarDoc();
          }}
          okText="Incluir"
          okButtonProps={{ disabled: !chave, shape: "round", icon: <CheckOutlined /> }}
        >
          <Row>
            <Col xs={24} sm={12}>
              <Form.Item label="Nome Documento"
                labelCol={{ span: 14 }}
                labelAlign="left"
                name="nmDocumentoPfPenalidade"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Campo Nome do Documento obrigatório não preenchido",
                  },
                ]}
              >
                <Input placeholder="Nome" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={6}>
              <Form.Item label="Número"
                name="nuDocumentoPfPenalidade"
                colon={false}
              >
                <Input placeholder="Número" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={6}>
              <Form.Item label="Data"
                name="dtDocumentoPfPenalidade"
                colon={false}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                  placeholder="Selecionar Data"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="space-between">
            <Col xs={24} md={12} xl={5}>
              <SelecionarArquivo
                setChave={setChave}
                identificador={true}
              />
            </Col>
          </Row>

        </Modal>

      </>

      <Row style={{ display: exibirDocCadastrado }}>
        <Col
          xs={24}
          sm={24}
        >
          <Table
            size="small" columns={columns} dataSource={documentos} pagination={false} />
        </Col>
      </Row>
    </>
  )
};

export default PessoaFisicaPenalidadeDocumento;